export default __webpack_public_path__ + "static/media/ic_ftm_30.edb5d5a2.svg";